module.exports = __webpack_public_path__ + "img/d.4e8a1be4.png";